/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ContractState {
    Inactive = '0',
    Active = 1,
    Due = 2,
}
